<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card :loading="!loaded">
          <v-card-title>
            Presupuestos
            <v-icon style="margin-left: 0.25em" v-on:click="getData">mdi-reload</v-icon>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar Presupuesto" single-line
              hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="budgets" :search="search">

            <template v-slot:item.socialName="{ item }">
              <router-link :to="'/budget/' + item.projectID" class="clientLink">{{ item.socialName }}
              </router-link>
            </template>

            <template v-slot:item.total_end="{ item }">
              <b>{{ getParseTotal(item.total_end) }}€</b>
            </template>
            <template v-slot:item.status="{ item }">
              <span v-if="item.status === '0'" style="color:#E8AD00">Pendiente de confirmación</span>
              <span v-else-if="item.status === '1'" style="color:#217A2B">Aceptado</span>
              <span v-else-if="item.status === '2'" style="color:#90CAF9">Facturado</span>
              <span v-else-if="item.status === '4'" style="color:red">Rechazado</span>
            </template>
            <template v-slot:item.PDF="{ item }">
              <a :href="'https://invoicer.grupowapps.es/generator/budget/' + item.projectID + '/' + item.userID" target="_blank"
                rel="nofollow">
                <v-icon>mdi-text-box-multiple-outline</v-icon>
              </a>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn v-if="item.status === '0'" color="green lighten-3" class="ma-2 white--text" outlined width="150"
                @click="acceptBudget(item.projectID)">
                Aceptar
                <v-icon right dark>mdi-check</v-icon>
              </v-btn>
              <v-btn v-if="item.status === '0'" color="red lighten-3" class="ma-2 white--text" outlined width="150"
                @click="deniedBudget(item.projectID)">
                Rechazar
                <v-icon right dark>mdi-close</v-icon>
              </v-btn>
              <v-btn v-if="item.status === '1'" color="blue lighten-1" class="ma-2 white--text" width="150" outlined>

                Contrato
                <v-icon right dark>mdi-file-document</v-icon>
              </v-btn>
              <v-btn v-if="item.status === '1'" color="blue lighten-1" class="ma-2 white--text" outlined width="150"
                @click="invoiceBudget(item.projectID)">
                Facturar
                <v-icon right dark>mdi-file-document-check-outline</v-icon>
              </v-btn>
              <v-btn v-if="item.status === '1'" color="blue lighten-1" class="ma-2 white--text" outlined width="150"
                @click="finishBudget(item.projectID)">
                Finalizar
                <v-icon right dark>mdi-file-document-check-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <newproject :refresh="getData" />
  </v-container>
</template>

<script>
import Newproject from "../components/home/newproject";
export default {
  name: "Budgets",
  components: { Newproject },
  data() {
    return {
      budgets: [],
      headers: [
        {
          text: 'Presupuesto Nº',
          align: 'start',
          sortable: false,
          value: 'projectID',
        },
        { text: 'Cliente', value: 'socialName' ,sortable: false},
        { text: 'Comentario', value: 'name',sortable: false },
        { text: 'Fecha', value: 'date_add',sortable: false },
        { text: 'Total', value: 'total_end',sortable: false },
        { text: 'Estado', value: 'status' ,sortable: false},
        { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Ver PDF', value: 'PDF', sortable: false },
      ],
      search: '',
      loaded: false
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/proyectos/' + localStorage.token;
      this.axios.get(url).then(response => {
        this.budgets = response.data.projects;
        this.loaded = true;
      });
    },
    getParseTotal(total) {
      return parseFloat(total).toFixed(2)
    },
    acceptBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/actualizarproyecto';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('pid', bid);
      formData.set('status', 1);
      this.axios.post(url, formData).then(() => {
        this.getData();
      });
    },
    deniedBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/actualizarproyecto';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('pid', bid);
      formData.set('status', 4);
      this.axios.post(url, formData).then(() => {
        this.getData();
      });
    },
    finishBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/actualizarproyecto';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('pid', bid);
      formData.set('status', 2);
      this.axios.post(url, formData).then(() => {
        this.getData();
      });
    },
    invoiceBudget(bid) {
      this.loaded = false;
      let url = this.base_url + '/invV2/admin/actualizarproyecto';
      let formData = new FormData();
      formData.set('token', localStorage.token);
      formData.set('pid', bid);
      formData.set('status', 2);
      this.axios.post(url, formData).then(() => {
        this.getData();
      });
    }
  }
}
</script>

<style scoped>
.clientLink {
  text-decoration: none;
  color: black;
  font-weight: bold;
}

.clientLink:hover {
  color: #90CAF9 !important;
}
</style>